import security from '../../../utils/security'
import http from '../../../utils/http'
import {
  AGREEMENT_CUSTOMER_LOADING,
  AGREEMENT_CUSTOMER_SUCCESS,
  AGREEMENT_CUSTOMER_ERROR,
} from './mutation-types'

const state = {
  loading: false,
  error: '',
  items: []
}

function error (error) {
  return {type: AGREEMENT_CUSTOMER_ERROR, error}
}

function loading (loading) {
  return {type: AGREEMENT_CUSTOMER_LOADING, loading}
}

function success (items) {
  return {type: AGREEMENT_CUSTOMER_SUCCESS, items}
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
}

const actions = {
  load ({commit}, values) {
    commit(loading(true))
    commit(error(null))
    return http.fetch('/customers?pagination=false&order[name]=asc')
      .then(response => {
        commit(loading(false))
        return response.json()
      })
      .then(data => {
        commit(success(data['hydra:member']));
      })
      .catch(e => {
        commit(loading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        commit(error(e.message))
      })
  },
}

const mutations = {
  [AGREEMENT_CUSTOMER_ERROR] (state, payload) {
    state.error = payload.error
  },
  [AGREEMENT_CUSTOMER_LOADING] (state, payload) {
    state.loading = payload.loading
  },
  [AGREEMENT_CUSTOMER_SUCCESS] (state, payload) {
    state.items = payload.items
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agreement/customer.js